import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { TrainingProgramBuilder } from '@/features/organizations/settings/training-programs/builder'

// R-3b-2: the `partner_template_updated` obligation deep-links to
// `?compare=1` on this route (packages/utils/src/compliance/deep-links.ts) —
// the builder opens the compare view (screen 7) when it is present. `catch(0)`
// makes a malformed value ("compare=yes") behave like "absent" instead of a
// 400 from the route loader.
const trainingProgramBuilderSearchSchema = z.object({
  compare: z.number().optional().catch(0),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/training-programs/$programId'
)({
  component: TrainingProgramBuilder,
  validateSearch: trainingProgramBuilderSearchSchema,
})

